const Configurl = {
    "DefaultOrganizationLogo": "https://inazstgpfs3001.blob.core.windows.net/assets/Kenverse/Alumni/Images/ken42(png).png",
    "OrganizationName": "Alumni",
    "OrganizationbaseURL": "https://dev-alumniportal.ken42.com/",
    "apiUrl": "dev-alumniportal.ken42.com",
    "BackendbaseURL":"https://alumni-node-dev-api.ken42.com/"
};

export default Configurl;